import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { ThemePalette } from 'views/SurvivalAnalysis/Helper/Icons/theme.squares';

// Define the shape of value items
interface ValueItem {
  header: any;
  value: any;
}

// Extend the component's props to accept an onClick handler
interface AssetValueCardProps {
  title: string;
  values: ValueItem[];
  enableDarkTheme: boolean;
  onClick?: () => void; // Add optional onClick prop
}

const AssetValueCard: React.FC<AssetValueCardProps> = ({
  title,
  values,
  enableDarkTheme,
  onClick, // Destructure the onClick prop
}) => {
  return (
    <Card
      onClick={onClick} // Apply the onClick event to the Card
      sx={{
        mb: 2,
        cursor: onClick ? 'pointer' : 'default', // Change cursor if onClick is provided
        background: enableDarkTheme
          ? ThemePalette.dark.tableBackground
          : ThemePalette.light.tableBackground,
      }}
    >
      <CardContent>
        <Typography
          sx={{
            color: enableDarkTheme
              ? ThemePalette.typography.white
              : ThemePalette.typography.black,
          }}
          variant="body2"
          fontSize={12}
        >
          {title}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          {values.map((item, index) => (
            <React.Fragment key={index}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: enableDarkTheme
                      ? ThemePalette.typography.white
                      : ThemePalette.typography.black,
                  }}
                >
                  {item.header}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: enableDarkTheme
                      ? ThemePalette.typography.white
                      : ThemePalette.typography.black,
                  }}
                >
                  {item.value}
                </Typography>
              </Box>

              {index < values.length - 1 && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    height: '20px',
                    alignSelf: 'center',
                    borderColor: enableDarkTheme
                      ? ThemePalette.typography.lightGrey
                      : ThemePalette.typography.grey,
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default AssetValueCard;
